import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";

function ProjectTeamForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectTeams = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-teams/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_project_id: data.organization_project_id || "",
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          project_team_name: data.project_team_name || "",
          project_team_short_name: data.project_team_short_name || "",
          description: data.description || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project Category data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchProjectTeams();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_id: "",
    project_team_name: "",
    project_team_short_name: "",
    description: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.organization_project_id) errors.organization_project_id = "Project is required";
    if (!formData.project_team_name) errors.project_team_name = "Project Team Name is required";
    if (formData.project_team_name.length > 150) errors.project_team_name = "Max 150 characters allowed";
    if (formData.project_team_short_name && formData.project_team_short_name.length > 20)
      errors.project_team_short_name = "Max 20 characters allowed";
    if (formData.description && formData.description.length > 255)
      errors.description = "Max 255 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  const [selectOptions, setSelectOptions] = useState({
    Projects: []
  })

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/projects`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Projects is : ", response);

      setSelectOptions((prev) => ({ ...prev, Projects: response.data.data }));
    } catch (e) {
      console.error("Failed to load Projects");
    }
  };

  useEffect(() => {
    if(org?.organization_id){ fetchProjects();}
   
  }, [org?.organization_id]);


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
entities?.organization_entity_id || null;
    console.log("organization_entity_id is : ", organization_entity_id);


    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-teams/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Team updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-teams`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Team added");
      }

      navigate("/project-team");
    } catch (err) {
      if (err.response?.status === 422) {toast.error("Please fix the validation errors.");
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

console.log("formdarta ehr eis : " , formData);



  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project Teams"}
        addMessage={"Project Teams"}
        homeLink={"/project-team"}
        homeText={"Project Teams"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

              

<Autocomplete
  fullWidth
  options={selectOptions?.Projects || []}
  getOptionLabel={(option) => option.project_name || ""}
  value={
    selectOptions?.Projects?.find(
      (p) => p.organization_project_id === formData.organization_project_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_id: newValue ? newValue.organization_project_id : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project *"
      error={!!formErrors.organization_project_id}
      helperText={formErrors.organization_project_id}
    />
  )}
/>



                <TextField
                  fullWidth
                  name="project_team_name"
                  label="Project Team Name *"
                  value={formData.project_team_name}
                  onChange={handleChange}
                  error={!!formErrors.project_team_name}
                  helperText={formErrors.project_team_name}
                />

                <TextField
                  fullWidth
                  name="project_team_short_name"
                  label="Project Team Short Name "
                  value={formData.project_team_short_name}
                  onChange={handleChange}
                  error={!!formErrors.project_team_short_name}
                  helperText={formErrors.project_team_short_name}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Description "
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />

                {/* <TextField
                  select
                  fullWidth
                  name="is_active"
                  label="Is Active"
                  value={formData.is_active}
                  onChange={handleChange}
                  error={!!formErrors.is_active}
                  helperText={formErrors.is_active}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </TextField> */}

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectTeamForm